import { Navigate } from 'react-router-dom';
import { useMember } from '../../hooks/useMember';
import { functionsFor } from '../../lib/driverAppTabs';
import { lastFunction } from '../../lib/lastFunction';

/**
 * The Functions tab: the records this member's role lets them work in
 * (impounds, invoices, inspections). It opens on the page they last had
 * open, or the first, and each page's title moves between them
 * (FunctionPage). The tab is an office role's, and shows only when there
 * is at least one; someone who only drives has each page as a tab instead.
 */
export function FunctionsScreen() {
  const pages = functionsFor(useMember());
  const last = lastFunction();
  const page = pages.find((item) => item.id === last) ?? pages[0];
  if (!page || !('screen' in page.opens)) return <Navigate to="/" replace />;
  return <Navigate to={page.opens.screen} replace />;
}
